import axios from "axios";
import url from "../config/urlServiceConfig";

const dashboardAPI = {
  getGeneralDashboardData: (id) => axios.get(`GeneralDashboard/${id || 0}`),
  getValidYears: () => axios.get(`${url.dashboard}/ValidYears`),
  getStrategicPerformanceData: (body) =>
    axios.post(`${url.dashboard}/StrategicPerformance`, body),
  getSectorsPerformanceData: (body) =>
    axios.post(`${url.dashboard}/Sectorial`, body),
  getLevelTwoObjectivesPerformanceData: (body) =>
    axios.post(`${url.dashboard}/SecondLevelObjectives`, body),
  getFilterDate: () => axios.get(`${url.dashboard}/FilterDate`),
};

export default dashboardAPI;
